import React, { useEffect } from "react";
import { BankStatementsPaper } from "@components/paper/paper";
import { BankStatementForm } from "@containers/PersonalLoan/containers/BankStatementStep/bankStatementForm";
import { withLoanForm } from "../withLoanForm";
import Wrapper from "../../components/bankstatement/bankStatement.styles";
import ContentWrapper from "@components/contentWrapper/contentWrapper";
import { BankStatementPrompt } from "../../components/bankstatement/bankStatementPrompt";
import { useHideButton, useSetOnSubmitDefault } from "../../context/formContext/submitButton";
import { usePrevious } from "react-use";
import { useSetTitle } from "../../context/formContext/header";
import { useSelector } from "react-redux";
import { LoaderBackground } from "./loaderBackground";
import { NoMarginRow, NoPaddingCol } from "@components/leftGrid";

const bankStatementReferralCodeIsSet = (bankStatementReferralCode) => {
  return bankStatementReferralCode && bankStatementReferralCode.length > 0;
}

const hasNewReferralCode = (bankStatementReferralCode, previousBankStatementReferralCode) => {
  return bankStatementReferralCode !== previousBankStatementReferralCode;
}

const useBankStatementSubmission = (submitForm, bankStatementReferralCode) => {
  const previousBankStatementReferralCode = usePrevious(bankStatementReferralCode);
  
  useEffect(() => {
    const delayedSubmit = () => {
      const timeToCompleteTickAnimation = 2500;
      setTimeout(() => {
        submitForm();
      }, timeToCompleteTickAnimation);
    };

    if (hasNewReferralCode(bankStatementReferralCode, previousBankStatementReferralCode) && bankStatementReferralCodeIsSet(bankStatementReferralCode)) {
      delayedSubmit();
    }
  }, [bankStatementReferralCode, previousBankStatementReferralCode, submitForm]);
};

const BankStatementFormWrap = (props) => {
  const {
    values: {
      bankStatementReferralCodeSkip,
      bankStatementReferralCode
    } = {},
    errors,
    touched,
    setFieldValue,
    submitForm,
  } = props;
  
  const { isFetching } = useSelector(({loanForm}) => loanForm);
  useBankStatementSubmission(submitForm, bankStatementReferralCode);
  useHideButton();
  useSetOnSubmitDefault();
  useSetTitle("Your Bank Statement");
  
  const showBankStatements = bankStatementReferralCodeSkip === false;
  return (
    <BankStatementsPaper>
      <ContentWrapper paddingTop={10}>
        <NoMarginRow>
          <NoPaddingCol>
            <Wrapper>
              <BankStatementForm
                setFieldValue={setFieldValue}
                show={showBankStatements}
                allowSkip={true}
                errorMessage={
                  touched.bankStatementReferralCode ? errors.bankStatementReferralCode : ""
                }
              />
              <BankStatementPrompt 
                showBankStatements={showBankStatements} 
                setFieldValue={setFieldValue} 
              />
              <LoaderBackground loading={isFetching} />
            </Wrapper>
          </NoPaddingCol>
        </NoMarginRow>
      </ContentWrapper>
    </BankStatementsPaper>
  );
};
export default withLoanForm(BankStatementFormWrap);
